import { render, staticRenderFns } from "./GenerateLabels.vue?vue&type=template&id=27972e29"
import script from "./GenerateLabels.vue?vue&type=script&lang=ts"
export * from "./GenerateLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports